import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,{directives:[{name:"mask",rawName:"v-mask",value:('+1 (###) ###-####'),expression:"'+1 (###) ###-####'"}],ref:_vm.inputField,attrs:{"label":_vm.label,"rules":_vm.rules || _vm.defaultRules},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }